import { currentAuthKind } from './auth.js';
import { resolveActiveOrg } from './active-org.js';

/**
 * Guard org-targeting writes: a human (OAuth) caller must have chosen an org first, so the write
 * doesn't silently land in the backend's primary org. `rec_` tokens are exempt — their org is
 * bound into the token and the backend ignores the `X-Rekor-Active-Org` header for them (so a
 * `.rekor.yaml` would be moot). Call (awaited) at the top of the action.
 */
export async function requireActiveOrg(): Promise<void> {
  if ((await currentAuthKind()) === 'rec') return; // org is bound into the token
  if (resolveActiveOrg().orgId) return;
  throw new Error(
    'No active organization. Run `rekor init` to bind this repo to an org, pass `--org <id>`, or set REKOR_ORG.',
  );
}
